import request from '@/utils/request'

//反馈列表
export function getFeedbackList(data) {
    return request({
        url: '/backend/ProblemFeedback/getFeedbackList',
        method: 'post',
        data: data
    })
}

//查看回复记录接口
export function getReplyList(data) {
    return request({
        url: '/backend/ProblemFeedback/getReplyList',
        method: 'post',
        data: data
    })
}

//客服反馈保存接口
export function feedbackStore(data) {
    return request({
        url: '/backend/ProblemFeedback/feedbackStore',
        method: 'post',
        data: data
    })
}

//反馈已完结接口
export function feedbackComplete(data) {
    return request({
        url: '/backend/ProblemFeedback/feedbackComplete',
        method: 'post',
        data: data
    })
}

//设置反馈变更人接口
export function setFeedbackAdminId(data) {
    return request({
        url: '/backend/ProblemFeedback/setFeedbackAdminId',
        method: 'post',
        data: data
    })
}